var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3592 4.09871C12.7057 4.26523 12.926 4.6156 12.926 5.00001V19C12.926 19.3844 12.7057 19.7348 12.3592 19.9013C12.0127 20.0678 11.6015 20.021 11.3013 19.7809L6.57524 16H2.92603C2.37374 16 1.92603 15.5523 1.92603 15V9.00001C1.92603 8.44772 2.37374 8.00001 2.92603 8.00001H6.57524L11.3013 4.21914C11.6015 3.979 12.0127 3.93219 12.3592 4.09871ZM10.926 7.08063L7.55072 9.78088C7.37341 9.92273 7.1531 10 6.92603 10H3.92603V14H6.92603C7.1531 14 7.37341 14.0773 7.55072 14.2191L10.926 16.9194V7.08063Z",
    fill: "#FB7B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2891 4.22247C19.6796 3.83201 20.3128 3.8321 20.7033 4.22269C22.7655 6.28549 23.9239 9.08288 23.9239 11.9997C23.9239 14.9165 22.7655 17.7139 20.7033 19.7767C20.3128 20.1673 19.6796 20.1674 19.2891 19.7769C18.8985 19.3864 18.8984 18.7533 19.2889 18.3627C20.9761 16.6749 21.9239 14.3862 21.9239 11.9997C21.9239 9.61321 20.9761 7.32444 19.2889 5.63669C18.8984 5.2461 18.8985 4.61294 19.2891 4.22247ZM15.7591 7.75247C16.1496 7.36201 16.7828 7.3621 17.1733 7.75269C18.2981 8.87785 18.93 10.4037 18.93 11.9947C18.93 13.5857 18.2981 15.1115 17.1733 16.2367C16.7828 16.6273 16.1496 16.6274 15.7591 16.2369C15.3685 15.8464 15.3684 15.2133 15.7589 14.8227C16.5087 14.0726 16.93 13.0553 16.93 11.9947C16.93 10.934 16.5087 9.9168 15.7589 9.16669C15.3684 8.7761 15.3685 8.14294 15.7591 7.75247Z",
    fill: "#FB7B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.7773b264b3c3da52b4eb66788a97844d.svg";
export { ForwardRef as ReactComponent };